const POLL_TYPES = {
  SURVEY_JS: "SurveyJs",
  POLL: "poll",
  SURVEY: "survey",
  INTERACTIVE: "interactive",
};

function getPollType(poll) {
  if (typeof poll?.type === "string") return poll.type.trim();
  if (typeof poll?.category === "string") return poll.category.trim();
  return "";
}

export function isInteractiveQuiz(poll) {
  // A quiz is marked by EITHER field: trusting only `type` (first non-empty
  // wins) let `{ type: "poll", category: "interactive" }` fall through every
  // list — PollPage dropped it while the quiz list ignored it, so the item
  // was invisible everywhere. Both markers now count in every consumer.
  const t = getPollType(poll);
  if (t === POLL_TYPES.INTERACTIVE || t === "interactive-quiz") return true;
  const c = typeof poll?.category === "string" ? poll.category.trim() : "";
  return c === POLL_TYPES.INTERACTIVE || c === "interactive-quiz";
}

export function getPollPoints(poll) {
  const raw = poll?.spq?.point ?? poll?.points;
  const n = Number(raw);
  if (Number.isFinite(n) && n > 0) return n;
  return null;
}
